import React, { Component } from 'react';

export class FAQ extends Component {

  render() {
    const {id, style} = this.props
    const customAttributes = {
      id, style
    };
    return (
      <div {...customAttributes}>{this.props.children}</div>
    );
  }
}


export default FAQ;
